// Components
const TheHeader = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: 'the-header' */ "@/app/views/main-view/_shared/the-header/the-header.vue"
	)
const TheSidebar = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: 'the-sidebar' */ "@/app/views/main-view/_shared/the-sidebar/the-sidebar.vue"
	)
const BreederSidebar = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: 'breeder-sidebar' */ "@/app/views/main-view/_shared/breeder-sidebar/breeder-sidebar.vue"
	)
const TheFooter = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: 'the-footer' */ "@/app/views/main-view/_shared/the-footer/the-footer.vue"
	)
const TheStickyMenu = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: 'the-sticky-menu' */ "@/app/views/main-view/_shared/the-sticky-menu/the-sticky-menu.vue"
	)
const ModalAddPet = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-add-pet" */ "@/app/views/main-view/_shared/_components/switch-pet/modals/modal-add-pet/modal-add-pet.vue"
	)

const ErrorView = () => import(/*webpackChunkName: "error-view" */ "@/app/views/error-view/error-view.vue")


// Event Bus
import EventBus from "@/app/bus/event-bus.js"

// Constants
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';
import { USER_ROLES } from '@/app/constants/status-constants';

export default {
	name: "MainView",
	components: {
		TheHeader,
		TheSidebar,
		BreederSidebar,
		TheFooter,
		TheStickyMenu,
		ModalAddPet,
		ErrorView
	},
	data() {
		return {
			hasMenuMargin: false,
			isAppFixed: false,
			modalContent: {},
			isBreederRoutesAccessible: true,
			isError: false
		}
	},
	computed: {
		isNativeApp() {
			return this.$store.getters.getIsNativeApp
		},
		isSocial() {
			return (
				this.$route.path === "/social" || this.$route.path === "/social/group" || this.$route.path === "/post"
			)
		},
		userRole() {
			return this.$store.getters.getUserDetails.userRole
		},
		hasSwitchToBreederRole(){
			return this.$store.getters.getHasSwitchToBreederRole;
		}, 
	},
	watch: {
		'$route': {
			immediate: true,
			handler(url) {
				// set it to true by default
				this.isBreederRoutesAccessible = true;

				if(url.path && (!Object.values(BREEDER_ROUTES).includes(url.path))){
					this.$store.commit('setHasSwitchToBreederRole', false);
				} else{
					
					if(this.$store.getters.getHasSwitchToBreederRole || this.$store.getters.getUserDetails.isBreeder || this.$store.getters.getUserDetails.userRole === USER_ROLES.BREEDER){
						this.$store.commit('setHasSwitchToBreederRole', true);
						this.isBreederRoutesAccessible = true;
						
					} else {
						const allowedRoutes = [BREEDER_ROUTES.PUPPY_SALES, BREEDER_ROUTES.SELL_YOUR_PUPPY_INFO, BREEDER_ROUTES.BREEDER_BIO, BREEDER_ROUTES.LITTER_LIST];
						
						if(allowedRoutes.includes(url.path)){
							this.isBreederRoutesAccessible = true;
						} else {
							this.isBreederRoutesAccessible = false;
						}
					}

				}

			}
		},
		isError(newValue) {
			this.isBreederRoutesAccessible = !newValue
		},
	},
	created() {
		EventBus.$on("addMenuMargin", (hasMenuMargin) => {
			this.hasMenuMargin = hasMenuMargin
		})

		EventBus.$on("makeAppFixed", (isAppFixed) => {
			this.isAppFixed = isAppFixed
		})
		EventBus.$on("errorUnAuthorizeUser", (hasError) => {
			this.isError = hasError
		})
	},
	beforeDestroy() {
		EventBus.$off("addMenuMargin", (hasMenuMargin) => {
			this.hasMenuMargin = hasMenuMargin
		})

		EventBus.$off("makeAppFixed", (isAppFixed) => {
			this.isAppFixed = isAppFixed
		})

		EventBus.$off("errorUnAuthorizeUser", (hasError) => {
			this.isError = hasError
		})
	},
	methods: {
		addAnotherPet() {
			this.$refs.modalAddPet.show()
		},
	},
}
